import { slideShow, slideHide } from './animations';

interface Target {
	open: () => void;
	close: () => void;
}

interface Toggle {
	open: () => void;
	close: () => void;
}

const createTarget = (element: HTMLElement) => {
	let display: string;

	const storeDisplayValue = () => {
		if (!display) {
			display = window.getComputedStyle(element).display;
		}
	};

	const open = () => {
		slideShow(element);
	};

	const close = (immediate = false) => {
		storeDisplayValue();
		if (immediate) {
			element.style.display = 'none';
		} else {
			slideHide(element);
		}
	};

	return {
		open,
		close,
	};
};

const createToggle = (
	button: HTMLElement,
	targetsArgument: HTMLElement[],
	otherToggles: Toggle[],
): Toggle => {
	const defaultHidden = button.getAttribute('data-toggle-default') == 'hidden';
	let isOpen = true;

	const targets = targetsArgument.map(createTarget);

	const open = () => {
		if (isOpen) return;

		button.setAttribute('aria-pressed', 'true');
		otherToggles.forEach((otherToggle) => otherToggle.close());
		targets.forEach((target) => target.open());

		isOpen = true;
	};

	const close = (immediate = false) => {
		if (!isOpen) return;
		button.setAttribute('aria-pressed', 'false');
		targets.forEach((target) => target.close(immediate));
		isOpen = false;
	};

	if (defaultHidden) {
		close(true);
	}

	button.addEventListener('click', (e) => {
		if (isOpen) {
			close();
		} else {
			open();
		}
	});

	return {
		open,
		close,
	};
};

document.addEventListener('DOMContentLoaded', function () {
	const buttons = document.querySelectorAll<HTMLElement>('[data-toggle]');
	if (buttons.length === 0) return;

	const toggles: Toggle[] = [];

	buttons.forEach((button) => {
		const selector = button.getAttribute('data-toggle');
		if (!selector) return;

		const targets = Array.from(
			document.querySelectorAll<HTMLElement>(selector),
		);
		if (targets.length === 0) return;

		toggles.push(createToggle(button, targets, toggles));
	});
});
